import type { Meta, StoryObj } from '@storybook/web-components';

import { createDocumentation } from '@/globals/documentation/story';
import docs from './pn-page-nav-item-docs.json';

const { argTypes, textContent } = createDocumentation(docs);

/** Page nav */
const meta: Meta<HTMLPnPageNavItemElement> = {
  title: 'Components/Navigation/Page Nav/Item',
  parameters: {
    actions: {
      handles: ['itemselection'],
    },
    docs: {
      description: {
        story: textContent,
      },
    },
  },
  args: {
    value: 'one',
    icon: '',
    href: '/one/',
  },
  argTypes,
};

type Story = StoryObj<HTMLPnPageNavItemElement>;

export default meta;

import { createPnPageMenu } from '../renderMenu';

export const PnPageNavItem: Story = {
  name: 'pn-page-nav-item',
  render: args => createPnPageMenu(args, { isItem: true }),
};

/** Use an icon on the nav item. */
export const PnPageNavItemIcon: Story = {
  name: 'pn-page-nav-item (icon)',
  render: PnPageNavItem.render,
  args: {
    icon: 'globe',
  },
};
